import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from 'src/app/app.component';

import { HostListComponent, HostDetailComponent } from '@serengeti/serengeti-monitoring';

import { ResourceAuthService } from '@serengeti/serengeti-resource';

const routes: Routes = [
	{ path: 'main', component: AppComponent, canActivate: [ResourceAuthService], children: [
		{ path: 'resource/monitoring/list', component: HostListComponent, outlet: 'content', canActivate: [ResourceAuthService],
		data: { title: 'resource.monitoring.list.tabs.dashboard.title', root: true }  },
		{ path: 'resource/monitoring/detail/:id/', component: HostDetailComponent, outlet: 'content', canActivate: [ResourceAuthService],
		data: { title: 'resource.monitoring.detail.title' }  },
		
	]}
];

@NgModule({
	declarations: [
	],
	imports: [
		RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true }),
		CommonModule
	],
	exports: [
	]
})
export class AppRoutingMonitoringModule { }
